var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Niepotwierdzeni użytkownicy")]),_c('v-spacer')],1),_c('unregistered-users-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }